import axios from "axios";
import Vue from "vue";
import router from "../../../router/widget-router";

export const fetchPaymentOptions = async ({ commit, dispatch }, params) => {
  return await axios
    .get(
      `pdv/event/payment-options/${params.event}/${params.pdv}/${params.value}`,
      { params: { cupom: params.coupon } }
    )
    .then((response) => {
      if (response.status === 200) {
        const {
          credit_card,
          credit_card_installments_with_no_interest,
          credit_card_total,
        } = response.data;

        commit("SET_PAYMENT_DETAILS", response.data);
        if (credit_card) {
          let totalValue = credit_card_total;

          let interests = null;
          const parcelas = [
            {
              text: `1x ${Vue.options.filters.currency(totalValue)}`,
              value: {
                instalments: 1,
                total: totalValue,
                interestAmount: totalValue,
              },
            },
          ];
          for (let i = 2; i <= 12; i++) {
            if (
              typeof response.data[`credit_card_${i}_value`] !== "undefined"
            ) {
              const value = Number(response.data[`credit_card_${i}_value`]);
              const instalmentText =
                i <= credit_card_installments_with_no_interest ? "" : "*";
              parcelas.push({
                text: `${i}x ${Vue.options.filters.currency(
                  value
                )}${instalmentText}`,
                value: {
                  instalments: i,
                  total: Number(response.data[`credit_card_${i}_total`]),
                  interestAmount: Number(
                    response.data[`credit_card_${i}_value`]
                  ),
                },
              });
            } else {
              break;
            }
          }
          interests = {
            id: "CC",
            label: "Cartão de Crédito",
            parcelas,
          };
          commit("SET_PAYMENT_OPTIONS_DETAILS", response.data);
          commit("SET_INTERESTS", interests);
        }
        return response;
      } else return response;
    })
    .catch((error) => {
      dispatch("openSnackbar", {
        message: error.response.data.message,
        color: "error",
      });
    });
};

export const setPaymentOption = ({ commit }, option) => {
  commit("SET_PAYMENT_OPTION", option);
};

export const setPartialPayment = ({ commit }, data) => {
  commit("SET_PARTIAL_PAYMENT", data);
};

export const getAvailableEmail = async (obj, email) => {
  return await axios.get(`clients/email/available/${email}`);
};

export const registerBuyerInfo = async (obj, params) => {
  return await axios.post(`pdv/orders/buyer/info`, params);
};

export const paymentBillet = async ({ getters, dispatch, commit }, params) => {
  let dataBillet = {
    ...params.buyer,
    ...params.billet,
    payment_type_id: 3, // Boleto
    event_id: params.event,
    order_id: params.order,
    delivery_option_id: 1,
    products_amount: getters.productsQuantity,
    total: getters.productsTotal,
    split_payment_total:
      getters.paymentDetails && getters.paymentDetails.split_payment
        ? getters.partialPayment
        : null,
  };

  if (getters.eventDetails.checkout_dados_nf === 2) {
    let location =
      getters.buyer && getters.buyer.locationModel
        ? getters.buyer.locationModel.split("/")
        : "";
    dataBillet.customer_city = location ? location[0] : "";
    dataBillet.customer_state = location ? location[1] : "";
    dataBillet.customer_country = location ? location[2] : "";
  }
  return await axios
    .post("pdv/orders/charge/billet", dataBillet)
    .then((response) => {
      if (response.status === 200) {
        commit("SET_FINAL_DETAILS", response.data);
        return response;
      } else return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 412) {
        dispatch("openSnackbar", {
          message: error.response.data.message,
        });
      }
      if (error.response && error.response.status === 410) {
        dispatch("openSnackbar", {
          message: "Pedido Inválido",
          color: "error",
        });
        dispatch("resetCheckout", params.event);
      } else {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
    });
};

export const paymentCard = async ({ getters, dispatch, commit }, params) => {
  let dataCard = {
    ...params.buyer,
    card_number: params.mercadoPago
      ? "1"
      : params.buyer.card_number.replaceAll(" ", ""),
    card_expiration: params.mercadoPago
      ? "1"
      : params.buyer.card_expiration.replaceAll("/", ""),
    card_cvv: params.mercadoPago ? "1" : params.buyer.card_cvv,
    installment_amount:
      params.buyer.installment_amount.instalments.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
    payment_type_id: 1, // Crédito
    delivery_option_id: 1,
    event_id: params.event,
    order_id: params.order,
    products_amount: getters.productsQuantity,
    interest_amount: getters.productsTotal,
    split_payment_total:
      getters.paymentDetails && getters.paymentDetails.split_payment
        ? getters.partialPayment
        : null,
    total: getters.productsTotal,
    coupon: getters?.couponDetails?.cupomData?.campaign_coupon,
  };

  if (getters.eventDetails.checkout_dados_nf === 2) {
    let location =
      getters.buyer && getters.buyer.locationModel
        ? getters.buyer.locationModel.split("/")
        : "";
    dataCard.customer_city = location ? location[0] : "";
    dataCard.customer_state = location ? location[1] : "";
    dataCard.customer_country = location ? location[2] : "";
  }

  let language = await localStorage.getItem("language");

  if (language) dataCard.idioma = language;

  if (params.mercadoPago) {
    dataCard = Object.assign(dataCard, params.mercadoPago);
  }

  return await axios
    .post("pdv/orders/charge/card", dataCard)
    .then((response) => {
      if (response.status === 200) {
        commit("SET_FINAL_DETAILS", response.data);
        if (
          response.data.status !== "paid" &&
          response.data.status !== "3ds" &&
          response.data.status !== "in_process"
        )
          dispatch("openSnackbar", {
            message: "Transação recusada",
            color: "error",
          });
        return response;
      } else return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 412) {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
      if (error.response && error.response.status === 422) {
        dispatch("openSnackbar", {
          message:
            "Seu pedido foi cancelado por excesso de tentativas de pagamento.",
          color: "error",
        });
      }
      if (error.response && error.response.status === 410) {
        dispatch("openSnackbar", {
          message: "Pedido Inválido",
          color: "error",
        });
        dispatch("resetCheckout", params.event);
      } else {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
    });
};

export const paymentPix = async ({ getters, dispatch, commit }, params) => {
  let dataPix = {
    ...params.buyer,
    delivery_option_id: 1,
    event_id: params.event,
    order_id: params.order,
    split_payment_total:
      getters.paymentDetails && getters.paymentDetails.split_payment
        ? getters.partialPayment
        : null,
  };

  if (getters.eventDetails.checkout_dados_nf === 2) {
    let location =
      getters.buyer && getters.buyer.locationModel
        ? getters.buyer.locationModel.split("/")
        : "";
    dataPix.customer_city = location ? location[0] : "";
    dataPix.customer_state = location ? location[1] : "";
    dataPix.customer_country = location ? location[2] : "";
  }
  return await axios
    .post("pdv/orders/charge/pix", dataPix)
    .then((response) => {
      if (response.status === 200) {
        commit("SET_PIX_DETAILS", response.data);
        return response;
      } else return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 410) {
        dispatch("openSnackbar", {
          message: "Pedido Inválido",
          color: "error",
        });
        dispatch("resetPurchase");
        router.push({
          name: "Cart",
          params: {
            event: params.event,
          },
        });
      } else {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
    });
};

export const paymentInvoice = async ({ getters, dispatch, commit }, params) => {
  let dataCard = {
    ...params.buyer,
    payment_type_id: 9,
    event_id: params.event,
    order_id: params.order,
    products_amount: getters.productsQuantity,
    interest_amount: getters.productsTotal,
    split_payment_total:
      getters.paymentDetails && getters.paymentDetails.split_payment
        ? getters.partialPayment
        : null,
    total: getters.productsTotal,
    coupon: getters?.couponDetails?.cupomData?.campaign_coupon,
  };

  if (getters.eventDetails.checkout_dados_nf === 2) {
    let location =
      getters.buyer && getters.buyer.locationModel
        ? getters.buyer.locationModel.split("/")
        : "";
    dataCard.customer_city = location ? location[0] : "";
    dataCard.customer_state = location ? location[1] : "";
    dataCard.customer_country = location ? location[2] : "";
  }

  let language = await localStorage.getItem("language");

  if (language) dataCard.idioma = language;

  if (params.mercadoPago) {
    dataCard = Object.assign(dataCard, params.mercadoPago);
  }

  return await axios
    .post("orders/charge/invoice", dataCard)
    .then((response) => {
      if (response.status === 200) {
        commit("SET_FINAL_DETAILS", response.data);
        return response;
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 412) {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
      if (error.response && error.response.status === 422) {
        dispatch("openSnackbar", {
          message:
            "Seu pedido foi cancelado por excesso de tentativas de pagamento.",
          color: "error",
        });
      }
      if (error.response && error.response.status === 410) {
        dispatch("openSnackbar", {
          message: "Pedido Inválido",
          color: "error",
        });
        dispatch("resetCheckout", params.event);
      } else {
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
      }
    });
};

export const resetCheckout = ({ commit, dispatch }, event) => {
  localStorage.removeItem(`wait-authentication-${event}`);
  localStorage.removeItem(`show-map-${event}`);
  localStorage.removeItem(`sector-selected-${event}`);
  localStorage.removeItem(`cart-order-route-${event}`);
  localStorage.removeItem(`isCouponCard-${event}`);
  localStorage.removeItem(`couponCode-${event}`);
  commit("SHOW_SECURITY_CHECK", false);
  dispatch("setExpirationDialog", false);
  dispatch("resetPurchase");
  commit("SET_SELECTED_SECTOR", null);
  commit("SET_LAST_ORDER_AND_CART", null);
  dispatch("setPaymentOption", null);
  commit("SET_ERROR_MESSAGE_CARD", "");
};

export const confirmOrder = async ({ getters, commit }, params) => {
  const payload = {
    body: {
      codigo_apresentacao: getters.orderDetails.codigo_apresentacao,
      codigo_evento: getters.orderDetails.codigo_evento,
      codigo_pedido: getters.orderDetails.codigo,
      cupom: "",
      expiration:
        getters.orderDetails.data * 1000 +
        (getters.orderDetails.segundos_expiracao_pedido / 60) * 60 * 1000,
      forma_pagamento: "CO",
      hash_pedido: getters.orderDetails.hash_pedido,
      op: "venda",
      parcelas: 1,
      pdv: getters.pdv,
      pos: getters.pos,
    },
    payment: "CO",
    delivery_option_id: 1,
    cart: getters.cartProducts,
    ...params.buyer,
    ...params.customer,
  };

  return await axios
    .post("pdv/orders/confirm", payload)
    .then((response) => {
      commit("SET_FINAL_DETAILS", response.data);
      return response.data;
    })
    .catch((err) => {
      console.error(`Failed confirming order`, err);
    });
};

export const confirmTokenOrder = async (
  { commit, dispatch, getters },
  params
) => {
  return await axios
    .post("pdv/orders/charge/card/confirm", params)
    .then((response) => {
      let copyDetails = getters.finalDetails;
      copyDetails.orderData = response.data.orderData;
      if (!params.desistencia) commit("SET_FINAL_DETAILS", copyDetails);
      return response;
    })
    .catch((err) => {
      if (err?.response?.data?.message)
        dispatch("openSnackbar", {
          message: err?.response?.data?.message,
          color: "error",
        });
      else
        dispatch("openSnackbar", {
          message: "Erro Inesperado",
          color: "error",
        });
      return err;
    });
};
